import { Styles } from "../../config"

const styles = {
	container: {},

	inputContainer: {
		sx: {
			height: "500px"
		}
	},

	input: (value) => {
		let defaultBorder = "2px solid #46557880"
		if (value) defaultBorder = `2px solid ${Styles.Color.primary75}`

		return {
			color: Styles.Color.primary,

			"& .MuiOutlinedInput-notchedOutline": {
				border: defaultBorder
			},

			"&:hover .MuiOutlinedInput-notchedOutline": {
				border: `2px solid ${Styles.Color.primary75}`
			},

			"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
				border: `2px solid ${Styles.Color.primary75}`
			}
		}
	},

	label: {
		color: Styles.Color.primary,

		"&.Mui-focused": {
			color: Styles.Color.primary
		}
	},

	option: {
		color: Styles.Color.primary
	},

	helperText: {
		color: Styles.Color.primary
	}
}

export default styles
